import * as API_HOME from '../../api/home'
import * as API_VIP_COFIG from '../../api/vip/configApi'
import * as API_VIP_COMMON_FILE from '../../api/vip/commonFileApi'

export default {
  namespaced: true,
  state: {
    modelList: [],
    dealmodelId: '',
    homemodelId: '',
    channeldetail: {},
    configDe: {},
    announcementArr: [],
    vipConfig: {},
    vipBannerFileList: [],
    vipAdFile: '',
    vipLogoFile: ''
  },
  mutations: {
    model(state, payload) {
      state.modelList = payload.modelList
      state.dealmodelId = payload.dealmodelId
      localStorage.setItem('modelId', state.dealmodelId)
    },
    setdetail(state, params) {
      state.channeldetail = params
      localStorage.setItem('detail', JSON.stringify(params))
    },
    config(state, params) {
      state.configDe = params.configDe
    },
    notice(state, params) {
      state.announcementArr = params.announcementArr
    },
    vipConfig(state, params) {
      state.vipConfig = params.vipConfig
    },
    vipCommonFile(state, params) {
      let vipBannerFileList = []
      let vipAdFile = []
      let vipLogoFile = []
      let vipCommonFile = params.vipCommonFileList
      // file_type 文件类型（3轮播图；4广告；5:LOGO
      if (vipCommonFile != null && vipCommonFile.length > 0) {
        vipCommonFile.forEach((item, i, array) => {
          if (item.fileType === 3) {
            vipBannerFileList.push(item)
          } else if (item.fileType === 4) {
            vipAdFile.push(item)
          } else if (item.fileType === 5) {
            vipLogoFile.push(item)
          }
        })

        state.vipBannerFileList = vipBannerFileList
        state.vipAdFile = vipAdFile[0]
        state.vipLogoFile = vipLogoFile[0]
      }
    }
  },
  actions: {
    model(context, payload) {
      return API_HOME.getAllCmsModel().then(res => {
        var dealmodelId = ''
        res.data.forEach(val => {
          if (val.modelShortName === 'dealCenter') {
            dealmodelId = val.modelId
          }
        })
        context.commit('model', {
          modelList: res.data,
          dealmodelId: dealmodelId
        })
      })
    },
    detail(context, data) {
      context.commit('setdetail', data)
    },
    config(context) {
      return API_HOME.getCmsConfig().then(res => {
        if (res.success) {
          context.commit('config', {
            configDe: res.data
          })
        }
      })
    },
    notice(context) {
      return API_HOME.getCmsNotice().then(res => {
        if (res.success) {
          context.commit('notice', {
            announcementArr: res.data
          })
        }
      })
    },
    vipConfig(context, params) {
      return API_VIP_COFIG.mapCmsVipConfigByVipCode(params).then(res => {
        if (res.success) {
          context.commit('vipConfig', {
            vipConfig: res.data
          })
        }
      })
    },
    vipCommonFile(context, params) {
      return API_VIP_COMMON_FILE.listCmsVipCommonFileByVipCode(params).then(res => {
        if (res.success) {
          context.commit('vipCommonFile', {
            vipCommonFileList: res.data
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/module.js